import ComingSoonCop from "components/ComingSoonCop";
import ParentScrollView from "components/ParentScrollView";
import ReactPlayer from "components/react-player/src/index";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { Image, View, useWindowDimensions } from "react-native";
import { useRef } from "react";
import VText from "components/VText";
import { StyleSheet } from "react-native";
import { Images } from "assets";
import GuestView from "components/aistylist/guestView";
import SearchView from "components/aistylist/searchView";
import { useSelector } from "react-redux";



export default function AiStylist() {

    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
  

    return (
        <ParentScrollView>
            {userProfile?.userId ? <SearchView /> : <GuestView />}
        </ParentScrollView>
    );
}


